<template>
  <div class="battertBelong-record">
    <div class="main-title">
      <p>电池归属记录</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>账户编号：</span>
        <el-input class="list-input" size="mini" placeholder="请输入手机号/账户编号" v-model="userAccountInfo"></el-input>
        <span>电池编号：</span>
        <el-input class="list-input" size="mini" placeholder="请输入电池设备编号/通讯板编号" v-model="batteryParam"></el-input>
        <span class="ml10">操作类型：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="sourceType">
          <el-option
            v-for="(item,key) in sourceTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="list">
        <span>时间</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="开始日期"
        ></el-date-picker>
        -
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="结束日期"
        ></el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>电池编号</th>
          <th>通讯板编号</th>
          <th>创建时间</th>
          <th>归属凭证编号</th>
          <th>归属用户</th>
          <th>归属端口</th>
          <th>操作类型</th>
          <th>操作用户</th>
          <th>备注</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ item.batteryNo }}</td>
          <td>{{ item.communicationBoardNo }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.voucherNo }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.chargePortInfo }}</td>
          <td>{{ item.sourceType }}</td>
          <td>{{ item.operateUser }}</td>
          <td>{{ item.remark }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='9'>暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'batteryBelongRecord',
  data() {
    return {
      title: '',
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      userAccountInfo: '',
      batteryParam: '',
      startTime: "",
      endTime: "",
      createTime: '',
      batteryNo: '',
      voucherNo: '',
      phone: '',
      chargePortInfo: '',
      sourceType: '',
      remark: '',
      sourceTypeList: [
        {
          id: '',
          name: '全部'
        }, {
          id: 0,
          name: '电池投放'
        }, {
          id: 1,
          name: '换电'
        }, {
          id: 2,
          name: '用户绑定电池'
        }, {
          id: 3,
          name: '运维编辑归属'
        }, {
          id: 4,
          name: '运维开门'
        }, {
          id: 5,
          name: '退还处理'
        }, {
          id: 6,
          name: '清空归属'
        }, {
          id: 7,
          name: '硬件上报BMS信息'
        }
      ],
      dataList: []
    }
  },
  mounted() {
    this.startTime = new Date(Utils.getCurrentDate() + ' 00:00').getTime();
    this.endTime = new Date(Utils.getCurrentDate() + ' 23:59').getTime();
    if (this.$route.query.batteryParam) {
      this.batteryParam = this.$route.query.batteryParam;
      this.queryBatteryBelongRecord();
    }
  },
  methods: {
    queryBatteryBelongRecord() {
      let self = this;
      let params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        startTime: this.startTime,
        endTime: this.endTime,
        batteryParam: this.batteryParam,
        userAccountInfo: this.userAccountInfo,
        sourceType: this.sourceType
      };
      this.$http.post('/managementPlatform/electricity/queryBatteryBelongReload', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryBatteryBelongRecord();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryBatteryBelongRecord();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryBatteryBelongRecord();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.queryBatteryBelongRecord();
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batteryBelongRecord.vue